import { GalleryContext } from "./chunk-JMBPVZMW.js";
import { Figure_default } from "./chunk-AN4JJSLI.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Gallery/Gallery.Item.tsx
import { useContext, forwardRef } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var FigureAsListItem = forwardRef((props, ref) => /* @__PURE__ */jsx(Figure_default, __spreadValues({
  as: "li",
  ref
}, props)));
var GalleryItem = _a => {
  var _b = _a,
    {
      children,
      itemNumber,
      badge,
      className
    } = _b,
    rest = __objRest(_b, ["children", "itemNumber", "badge", "className"]);
  const {
    id
  } = useContext(GalleryContext);
  return /* @__PURE__ */jsxs(FigureAsListItem, __spreadProps(__spreadValues({}, rest), {
    id: "".concat(id, "-item-").concat(itemNumber),
    role: "group",
    "aria-roledescription": "slide",
    className: clsx("pd:gallery-item", className),
    children: [children, badge && /* @__PURE__ */jsx("div", {
      className: "pd:absolute pd:left-3 pd:top-3",
      children: badge
    })]
  }));
};
var Gallery_Item_default = GalleryItem;
export { Gallery_Item_default };